
const ApartYouIds = [
    // "511e8df9-672d-42b1-9711-d82beb7baf64",
    "b4889f16-8dc7-40f5-814b-5a1ed90d3947",
    "8b62cf50-d136-402b-abbc-81fb0b3ac162",
    "7f1d1e0b-acea-4c79-b442-f9dc557c4956",
    "2c31590f-739c-46b3-aca6-665e83a518ea",
    "bd8df831-ce3d-4596-ad10-3bbc188ded7d",
    "8fcf8b78-ed33-4575-b00a-4c8be2886ce0",
    "54aa721b-8f04-495b-923c-07d90e08fb92",
    "fea1efb3-9d97-4374-ab72-109bda0a9819",
    "4c126315-cf81-4e93-93fb-57ca1b07d220",
    "de6a6244-3a0c-44fb-b1e8-53f38d94019a",
    "e2ba6052-9f7f-4213-93a7-094317fc722f",
    "cf9b040e-bcf6-4d55-adbb-9fc705183e9c",
    "58e23f10-b106-483d-830e-5414ce661bed",
    "c9d798bc-2fb0-482e-8b3a-4577b94e788f",
    "72501582-74d3-4308-b139-2ba80beded69",
    "bf91530e-77a0-42a5-8d77-f487fb3245ad"
];

const customStyles = {
    ApartYou: {
        fontSize: '15px',
        lineHeight: 1,
        color: 'rgb(102, 102, 102)',
        textTransform: 'uppercase',
        marginTop: 4,
        textAlign: 'center'
    }
};

const CustomStyles = (hotelId) => {
    if (ApartYouIds.includes(hotelId)) {
        return customStyles;
    }
    return null;
};

export default CustomStyles;
